import { useLocation, useNavigate } from 'react-router';

export const useNavigateBack = (fallbackReturnTo?: string) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  return () => {
    if (history.state.idx > 0 && !state?.isNavigatingUp) {
      navigate(-1);
    } else {
      navigate(fallbackReturnTo || '..', {
        state: { isNavigatingUp: true },
      });
    }
  };
};
